<div
  class="ch-panel"
  chPaidOverlay
  style="background: rgba(246, 247, 249, 0.451)"
  [ngClass]="{ 'panel-hidden': isPanelHidden }"
>
  <div class="flex flex-row justify-content-between">
    <div class="ch-panel-title">
      <div class="toggle-panel" (click)="togglePanel($event)">
        <i class="feather minus ch-panel-icon-title"></i> Pinned
      </div>
    </div>
    <div
      class="text-4xl justify-content-end align-content-center align-items-center h-full flex mr-5 mt-1 hide-panel-hidden"
    >
      <pin-filter
        (filterChanged)="pinFilterChanged($event)"
        [showUnpinnedOption]="false"
      ></pin-filter>
    </div>
  </div>
  <div class="ch-panel-content">
    <div
      id="jobs-tab"
      class="ch-tabs-content-wrapper"
      [ngClass]="{ 'component-loading': loading }"
    >
      <!-- <app-pinned-card [messageDebug]="true"></app-pinned-card>
      <app-pinned-card [emailDebug]="true"></app-pinned-card> -->
      @for (item of pinnedItems; track item) {
        <app-pinned-card [pinnedItem]="item"></app-pinned-card>
      }
    </div>

    @if (pinnedItems?.length == 0 && !loading) {
      <div class="empty-state empty-state-absolute text-center">
        <i
          class="tio-pin animated fadeInUp delay-3"
          style="font-size: 64px; opacity: 0.3"
        ></i>
        <h4 class="mt-4 animated fadeInUp delay-3">No pinned items</h4>
        <p class="animated fadeInUp delay-3">
          Use the <i class="tio-pin animated fadeInUp delay-3"></i> button on
          tasks, emails, etc.
        </p>
      </div>
    }
  </div>
</div>
